// Keyboard event typing extension
// eslint-disable-next-line spaced-comment, @typescript-eslint/triple-slash-reference
/// <reference path="../../global.d.ts" />

export * from "./behavior/index";

export * from "./controls/index";
export * from "./events/index";
export * from "./helpers/index";
export * from "./lg-dialog/index";
export * from "./lg-overlay/index";
export * from "./lg-tooltip/index";
export * from "./lg-snackbar/index";

export * from "./navigation/index";

// export * from "./pipes";
export { LgHighlightPipe } from "./pipes/highlight.pipe";
export { LgHighlightByRegexPipe } from "./pipes/highlight-by-regex.pipe";
export { LgCapitalizePipe } from "./pipes/lg-capitalize.pipe";
export { LgFormatMoneyPipe } from "./pipes/lg-format-money.pipe";
export { LgFormatMoneyScaledPipe } from "./pipes/lg-format-money-scaled.pipe";
export { LgFormatFloatPipe } from "./pipes/lg-format-float.pipe";
export { LgFormatIntegerPipe } from "./pipes/lg-format-integer.pipe";
export { LgFormatPercentSimplePipe } from "./pipes/lg-format-percent-simple.pipe";
export { LgFormatPercentPipe } from "./pipes/lg-format-percent.pipe";
export { LgFormatTextPipe } from "./pipes/lg-format-text.pipe";
export { LgFormatTypePipe } from "./pipes/lg-format-type.pipe";
export { LgFormatUnitPipe } from "./pipes/lg-format-unit.pipe";
export { LgLeftPadPipe } from "./pipes/lg-left-pad.pipe";
export { LgMonthNamePipe } from "./pipes/lg-month-name.pipe";
export { LgRemoveSymbolPipe } from "./pipes/lg-remove-symbol.pipe";
export { LgNewlinesPipe } from "./pipes/newlines.pipe";
export { LgMarkSymbolsPipe } from "./pipes/lg-mark-symbols.pipe";
export { LgTypeCastPipe } from "./pipes/lg-type-cast.pipe";
export { LgTypeGuardPipe } from "./pipes/lg-type-guard.pipe";

export * from "./providers";

export * from "./scrolling/index";
export * from "./tables/index";
export * from "./templating/index";
export * from "./text/index";
export * from "./virtual-scrolling/index";

export { UiCoreModule, appInitializerFactory } from "./ui-core.module";
